import { render, staticRenderFns } from "./myClass.vue?vue&type=template&id=d4f30dc8&scoped=true"
import script from "./myClass.vue?vue&type=script&lang=js"
export * from "./myClass.vue?vue&type=script&lang=js"
import style0 from "./myClass.vue?vue&type=style&index=0&id=d4f30dc8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4f30dc8",
  null
  
)

export default component.exports